import React from 'react';
import PetTraits from '../PetTraits';
import { useReveal } from '../../hooks/useReveal';
import type { Pet } from '../../types';
import '../../styles/DetailStory.css';

interface DetailStoryProps {
  pet: Pet;
}

const DetailStory: React.FC<DetailStoryProps> = ({ pet }) => {
  const hasHistory = !!pet.history;
  const hasHealth = !!pet.healthRequirements;
  const { ref, revealed } = useReveal<HTMLElement>();
  const cls = `detail-story psl-reveal${revealed ? ' is-in-view' : ''}`;

  if (!hasHistory && !hasHealth) {
    return (
      <section ref={ref} className={cls}>
        <PetTraits pet={pet} />
        <p className="detail-story__empty">
          Ainda estamos a escrever a ficha desta {pet.kind === 'cat' ? 'gata' : 'pata'} no caderno.
          Pergunta-nos diretamente — sabemos sempre mais do que está aqui escrito.
        </p>
      </section>
    );
  }

  return (
    <section ref={ref} className={cls}>
      <div className="detail-story__notes">
        {hasHistory && (
          <article className="detail-story__note detail-story__note--history">
            <div className="detail-story__kind">— história</div>
            <h2 className="detail-story__title">Como chegou</h2>
            <p>{pet.history}</p>
          </article>
        )}

        {hasHealth && (
          <article className="detail-story__note detail-story__note--health">
            <div className="detail-story__kind">— saúde</div>
            <h2 className="detail-story__title">Necessidades especiais</h2>
            <p>{pet.healthRequirements}</p>
          </article>
        )}
      </div>

      <PetTraits pet={pet} />
    </section>
  );
};

export default DetailStory;
